import { render, staticRenderFns } from "./VisitorDetail.vue?vue&type=template&id=b2e17340&scoped=true"
import script from "./VisitorDetail.vue?vue&type=script&lang=js"
export * from "./VisitorDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitorDetail.vue?vue&type=style&index=0&id=b2e17340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e17340",
  null
  
)

export default component.exports